import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { fetchData } from "../../../Services/GlobalService";
import Loader from "../../../Components/Loader";
import { toast } from "react-toastify";
import { downloadExcelDateFormat } from "../../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import * as Fa from "react-icons/fa";

const HDILSDiscountDefinition = () => {
  const BASE_URL = "Miscellaneous/HDILSDiscountDefinitionReport";
  const Endpoint = {
    GetContractPricingDataModified: "GetContractPricingDataModified",
  };

  const [loading, setLoading] = useState<boolean>(false);
  const [contractPricingData, setContractPricingData] = useState([]);

  const getContractPricingDataModified = async (type: any) => {
    setLoading(true);

    try {
      await fetchData(
        BASE_URL,
        Endpoint.GetContractPricingDataModified,
        `exportTag=${type}`
      ).then((res) => {
        if (type == "G") {
          setContractPricingData(res.Data);
          setLoading(false);

        }
        else {
          if (res.Data == null) {
            toast.warn("No Data Found.");
            setLoading(false);

          }
          else {
            downloadExcelDateFormat(
              res.Data,
              `HD_ILS_Discount_Definition_Report_${GetDateFormat()}.xlsx`
            );
            setLoading(false);

          }
        }

      });
    } catch (error: any) {
      setLoading(false);
      toast.error(error.Message);
    }
  };

  const handleDownload = () => {
    getContractPricingDataModified("E")
  };

  useEffect(() => {
    getContractPricingDataModified("G");
  }, []);

  if (loading) {
    return <Loader />;
  } else {
    return (
      <>
        <main>
          <div className="col-12 mb-5">
            <div className="row">
              {/* Breadcrumb  */}
              <div className="col-lg-12 col-md-12 col-sm-12">
                <nav aria-label="breadcrumb" className="drop-in">
                  <ol className="breadcrumb mx-0">
                    <li className="breadcrumb-item">Masters</li>
                    <li className="breadcrumb-item">Miscllaneous</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      HD-ILS Discount Definition Report
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <h3 className="py-2">HD-ILS Discount Definition Report</h3>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="float-end mb-2">
                  <button
                    type="button"
                    title="Save As Excel"
                    className="btn anime-btn"
                    onClick={() => handleDownload()}
                  >
                    Save As Excel
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="DataTable">
                <DataTable
                  value={contractPricingData}
                  paginator
                  rows={10}
                  filterDisplay="row"
                  scrollable
                  rowsPerPageOptions={[10, 25, 50]}
                  scrollHeight="80vh"
                  showGridlines
                  stripedRows
                >
                  <Column
                    field="PARENT CODE"
                    header="Parent Code"
                    filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="OFFER NO"
                    header="Offer Number"
                    filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="PRODUCT CODE"
                    header="Product Code"
                    filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column field="PRODUCT DESCRIPTION" header="Product Description" filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."></Column>
                  <Column field="START DATE" header="Start Date" filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."></Column>
                  <Column field="END DATE" header="End Date" filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."></Column>
                  <Column field="PRICE PER LTR" header="Price Per Litter" filter
                    filterMatchMode="contains"
                    filterPlaceholder="Search Here..."></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
};

export default HDILSDiscountDefinition;
